import { useCallback, useState } from 'react';

import { ModalProps } from '../../components/UI/Modal/types';

type UseModalReturn = {
  isOpen: boolean;
  content: React.ReactNode;
  modalProps?: Partial<ModalProps>;
  openModal: (newContent: React.ReactNode, props?: Partial<ModalProps>) => void;
  closeModal: () => void;
};

export const useModal = (): UseModalReturn => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [content, setContent] = useState<React.ReactNode>(null);
  const [modalProps, setModalProps] = useState<Partial<ModalProps>>({});

  const openModal = useCallback(
    (newContent: React.ReactNode, props?: Partial<ModalProps>) => {
      // Blur the currently focused element to prevent aria-hidden warning
      // when Ionic hides the router outlet behind the modal
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
      }
      setContent(newContent);
      setModalProps(props || {});
      setIsOpen(true);
    },
    [],
  );

  const closeModal = useCallback(() => setIsOpen(false), []);

  return { isOpen, content, modalProps, openModal, closeModal };
};
